import React, { useEffect, useState } from "react";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import { styled } from "@mui/material/styles";
import {
  useTheme,
  Box,
  List,
  ListItemButton,
  ListItemText,
  ListItemIcon,
  Divider,
  Typography,
  Switch,
  Grid,
  Button,
  useMediaQuery,
} from "@mui/material";
import { Link } from "react-router-dom";
import SecondaryCenterTemplate from "components/SecondaryCenterTemplate";
import { homeActions } from "actions";
import { connect } from "react-redux";
import SuccessDialog from "components/SuccessDialog";
import { phone as phoneFormatter } from "components/FormFields/formatters";

const settingsList = [{ title: "Notifications", link: "/MyAccount/Profile" }];

const CuverdSettings = (props) => {
  const theme = useTheme();
  const matchesSmall = useMediaQuery("(max-width:600px)");
  const [showSettings, setShowSettings] = useState(true);
  const [showNotifications, setShowNotifications] = useState(false);
  const [emailCheck, setEmailCheck] = useState(false);
  const [textCheck, setTextCheck] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [message, setMessage] = useState("");
  const [settingsTitle, setSettingsTitle] = useState("Cuverd® Settings");
  const storedUserInfo = JSON.parse(sessionStorage.getItem("userData"));

  const {
    allowEmailNotifications,
    denyEmailNotifications,
    allowTextNotifications,
    denyTextNotifications,
    resetNotificationsSettings,
    allowEmailInfo,
    allowTextInfo,
    denyEmailInfo,
    denyTextInfo,
  } = props;

  const showDetails = () => {
    setShowSettings(false);
    setShowNotifications(true);
    setSettingsTitle("Notifications");
  };

  const showList = () => {
    setShowSettings(true);
    setShowNotifications(false);
    setSettingsTitle("Cuverd® Settings");
  };

  useEffect(() => {
    document.getElementById("appcontent").scroll(0, 0);
    storedUserInfo && storedUserInfo.email
      ? setEmailCheck(true)
      : setEmailCheck(false);
    storedUserInfo && storedUserInfo.phone
      ? setTextCheck(true)
      : setTextCheck(false);
  }, []);

  useEffect(() => {
    if (allowEmailInfo || allowTextInfo || denyEmailInfo || denyTextInfo) {
      setShowSuccess(true);
      const info =
        (allowEmailInfo && allowEmailInfo.message) ||
        (allowTextInfo && allowTextInfo.message) ||
        (denyEmailInfo && denyEmailInfo.message) ||
        (denyTextInfo && denyTextInfo.message);
      setMessage(info);
    }
  }, [allowEmailInfo, allowTextInfo, denyEmailInfo, denyTextInfo]);
  const IOSSwitch = styled((props) => (
    <Switch
      focusVisibleClassName=".Mui-focusVisible"
      disableRipple
      {...props}
    />
  ))(({ theme }) => ({
    width: 46,
    height: 24,
    padding: 0,
    "& .MuiSwitch-switchBase": {
      padding: 0,
      margin: 2,
      transitionDuration: "300ms",
      top: "-1px",
      left: textCheck || emailCheck ? "4px" : "1px",
      borderRadius: "4px",
      "&.Mui-checked": {
        transform: "translateX(16px)",
        color: "#fff",
        "& + .MuiSwitch-track": {
          backgroundColor:
            theme.palette.mode === "dark" ? "#2ECA45" : "#65C466",
          opacity: 1,
          border: 0,
        },
        "&.Mui-disabled + .MuiSwitch-track": {
          opacity: 0.5,
        },
      },
      "&.Mui-focusVisible .MuiSwitch-thumb": {
        color: "#33cf4d",
        border: "6px solid #fff",
      },
      "&.Mui-disabled .MuiSwitch-thumb": {
        color:
          theme.palette.mode === "light"
            ? theme.palette.grey[100]
            : theme.palette.grey[600],
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: theme.palette.mode === "light" ? 0.7 : 0.3,
      },
    },
    "& .MuiSwitch-thumb": {
      boxSizing: "border-box",
      width: 22,
      height: 22,
      backgroundColor: "#fff",
    },
    "& .MuiSwitch-track": {
      borderRadius: 26 / 2,
      backgroundColor: theme.palette.mode === "light" ? "#E9E9EA" : "#39393D",
      opacity: 1,
      transition: theme.transitions.create(["background-color"], {
        duration: 500,
      }),
    },
  }));

  return (
    <SecondaryCenterTemplate pageTitle={settingsTitle}>
      <Grid container py={6}>
        <Grid
          item
          sm={8}
          xs={12}
          sx={{ margin: "auto", width: "100%", position: "relative" }}
        >
          {showSettings &&
            settingsList.map((listItem) => {
              return (
                <Box key={listItem.title}>
                  <List>
                    <Divider />
                    <ListItemButton
                      onClick={() => showDetails(listItem)}
                      sx={{ paddingLeft: "1rem", paddingBottom: "1rem" }}
                    >
                      <ListItemText
                        primary={listItem.title}
                        primaryTypographyProps={{
                          fontSize: "16px",
                          color: theme.palette.primary.main,
                          fontFamily: "Lato-Regular",
                        }}
                      />
                      <ListItemIcon>
                        <ChevronRight
                          sx={{ color: theme.palette.common.greenThree }}
                          fontSize="large"
                        />
                      </ListItemIcon>
                    </ListItemButton>
                    <Divider />
                  </List>
                </Box>
              );
            })}
          {showNotifications && (
            <Box>
              <Box>
                <Button
                  variant="outline"
                  sx={{
                    position: "absolute",
                    left: matchesSmall ? 0 : "-33%",
                    height: "40px",
                    top: matchesSmall ? "-71px" : "-64px",
                    padding: "4px 0px",
                    backgroundColor: "#fff",
                    "&:hover": {
                      backgroundColor: "#fff",
                    },
                  }}
                  onClick={() => showList()}
                >
                  <ChevronLeft
                    fontSize="large"
                    sx={{
                      color: theme.palette.common.greenTwo,
                      cursor: "pointer",
                    }}
                  />
                </Button>
              </Box>
              <Box mb={2} sx={{ textAlign: "left" }}>
                <Typography variant="h3LatoSemiBold">
                  Refill Savings Reminders
                </Typography>
              </Box>
              <Divider />
              <Box
                sx={{
                  display: "flex",
                  height: "350px",
                  flexDirection: "column",
                  justifyContent: "space-between",
                }}
              >
                <Box>
                  <List>
                    <ListItemButton>
                      <Box
                        component="div"
                        sx={{
                          display: "flex",
                          width: "100%",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <Box sx={{ display: "flex" }}>
                          <Box sx={{ marginRight: 4 }}>
                            <Typography
                              variant="h3LatoRegular"
                              sx={{ color: "#607277" }}
                            >
                              Text
                            </Typography>
                          </Box>
                          <Box>
                            <Typography variant="h3LatoSemiBold">
                              {storedUserInfo &&
                                phoneFormatter(storedUserInfo.phone)}
                            </Typography>
                          </Box>
                        </Box>
                        <Box>
                          {storedUserInfo && storedUserInfo.phone ? (
                            <IOSSwitch
                              checked={textCheck}
                              onClick={() => {
                                textCheck
                                  ? denyTextNotifications()
                                  : allowTextNotifications();
                                setTextCheck(!textCheck);
                              }}
                            />
                          ) : null}
                        </Box>
                      </Box>
                    </ListItemButton>
                    <Divider />
                  </List>
                  <List>
                    <ListItemButton>
                      <Box
                        component="div"
                        sx={{
                          display: "flex",
                          width: "100%",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <Box sx={{ display: "flex" }}>
                          <Box sx={{ marginRight: 4 }}>
                            <Typography
                              variant="h3LatoRegular"
                              sx={{ color: "#607277" }}
                            >
                              Email
                            </Typography>
                          </Box>
                          <Box>
                            <Typography variant="h3LatoSemiBold">
                              {storedUserInfo && storedUserInfo.email}
                            </Typography>
                          </Box>
                        </Box>
                        <Box>
                          {storedUserInfo && storedUserInfo.email ? (
                            <IOSSwitch
                              checked={emailCheck}
                              onClick={() => {
                                emailCheck
                                  ? denyEmailNotifications()
                                  : allowEmailNotifications();
                                setEmailCheck(!emailCheck);
                              }}
                            />
                          ) : null}
                        </Box>
                      </Box>
                    </ListItemButton>
                    <Divider />
                  </List>
                </Box>
                <Box>
                  <Box>
                    <Typography
                      variant="h5LatoBlack"
                      component={Link}
                      to="/MyAccount/Profile"
                      sx={{
                        color: theme.palette.common.greenFour,
                        textDecoration: "underline",
                      }}
                    >
                      <b>Update your mobile phone number and email address</b>
                    </Typography>
                  </Box>
                  {/* <Box mt={4}>
                    <Button
                      variant="text"
                      onClick={() => showList()}
                      sx={{ minWidth: { xs: "150px", sm: "150px", md: undefined } }}
                    >
                      CANCEL
                    </Button>
                  </Box> */}
                </Box>
              </Box>
            </Box>
          )}

          {showSuccess ? (
            <SuccessDialog
              showSuccessDialog={showSuccess}
              successMsg={message}
              onSuccessClick={() => {
                setShowSuccess(false);
                setMessage("");
                resetNotificationsSettings();
              }}
            />
          ) : null}
        </Grid>
      </Grid>
    </SecondaryCenterTemplate>
  );
};

const mapStateToProps = (state) => {
  return {
    allowEmailInfo: state.notificationSettings.allowEmailData,
    denyEmailInfo: state.notificationSettings.denyEmailData,
    allowTextInfo: state.notificationSettings.allowTextData,
    denyTextInfo: state.notificationSettings.denyTextData,
  };
};

const mapDispatchToProps = {
  allowEmailNotifications: () => homeActions.allowEmailNotifications(),
  denyEmailNotifications: () => homeActions.denyEmailNotifications(),
  allowTextNotifications: () => homeActions.allowTextNotifications(),
  denyTextNotifications: () => homeActions.denyTextNotifications(),
  resetNotificationsSettings: () => homeActions.resetNotificationsSettings(),
};

export default connect(mapStateToProps, mapDispatchToProps)(CuverdSettings);
